import {atom} from 'recoil';
import {Language} from 'webapp-lib/utils';

export const languageState = atom<Language>({
  key: 'languageState',
  default: Language.German,
});
